import { supabase } from "../config/supabase";

// Supabase Storage through the anon client. Each call is the one Storage
// request it names, answering Storage's own { data, error } so callers keep
// their error handling. Buckets the app reads: `rfq-files` (RFQ attachments,
// the customer's Excel) and `saved-remark-files`; a row's own
// `storage_bucket` is passed through where it has one.

/** A signed URL for one object, valid for `expiresIn` seconds. */
export const createSignedStorageUrl = (bucket: string, path: string, expiresIn: number) =>
  supabase.storage.from(bucket).createSignedUrl(path, expiresIn);

export const downloadStorageObject = (bucket: string, path: string) =>
  supabase.storage.from(bucket).download(path);

/** The objects in `directory` whose names match `search`. */
export const listStorageObjects = (bucket: string, directory: string, search: string) =>
  supabase.storage.from(bucket).list(directory, { search });

export const uploadStorageObject = (bucket: string, path: string, file: File) =>
  supabase.storage.from(bucket).upload(path, file);

export const removeStorageObjects = (bucket: string, paths: string[]) =>
  supabase.storage.from(bucket).remove(paths);
